import { useEffect, useState } from 'react';
import authService from '../services/authService';

const useRoles = () => {
  const [roles, setRoles] = useState([]);

  useEffect(() => {
    if (localStorage.getItem("access_token")) {
        const fetchRoles = async () => {
            try {
            const res = await authService.get("/roles/my"); // Эндпоинт для получения данных пользователя
            setRoles(res.data);
            } catch (err) {
            console.error(err);
            }
        };
        fetchRoles();
    }
  }, []);

  const hasRole = (role) => roles.includes(role);
  return { roles, hasRole };
};

export default useRoles;